export const documentDownloadHubTranslations = {
    en: {
        // Page Title
        healthCampDocumentHub: "Health Camp Document Download Hub",

        // Buttons
        document: "Document",
        previewAndDownload: "Preview & Download",
        viewMore: "View More",

        // Dialog Titles
        addEditDocument: "Add/Edit Document",
        documentDescription: "Document Description",
        deleteDoc: "Delete Doc",
        documentPreview: "Preview",

        // Tooltips
        removeDocument: "Remove Document",

        // Messages
        deleteDocumentConfirmation: "Are you sure you want to delete this Document? This action cannot be undone.",

        // Common
        noTitle: "No Title",
        other: "OTHER",

        // Module Name
        documentsModule: "Documents",
    },
    mr: {
        // Page Title
        healthCampDocumentHub: "आरोग्य शिबिर दस्तऐवज डाउनलोड केंद्र",

        // Buttons
        document: "दस्तऐवज",
        previewAndDownload: "पूर्वावलोकन आणि डाउनलोड",
        viewMore: "अधिक पहा",

        // Dialog Titles
        addEditDocument: "दस्तऐवज जोडा/संपादित करा",
        documentDescription: "दस्तऐवज वर्णन",
        deleteDoc: "दस्तऐवज हटवा",
        documentPreview: "पूर्वावलोकन",

        // Tooltips
        removeDocument: "दस्तऐवज काढा",

        // Messages
        deleteDocumentConfirmation: "तुम्हाला हा दस्तऐवज हटवायचा आहे का? ही क्रिया पूर्ववत केली जाऊ शकत नाही.",

        // Common
        noTitle: "शीर्षक नाही",
        other: "इतर",

        // Module Name
        documentsModule: "दस्तऐवज",
    }
};
